/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AssetClass2FromJSON(json) {
    return AssetClass2FromJSONTyped(json, false);
}
export function AssetClass2FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'assetClass2Name': !exists(json, 'assetClass2Name') ? undefined : json['assetClass2Name'],
        'assetClass1Name': !exists(json, 'assetClass1Name') ? undefined : json['assetClass1Name'],
        'attributeTemplateId': !exists(json, 'attributeTemplateId') ? undefined : json['attributeTemplateId'],
    };
}
export function AssetClass2ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'assetClass2Name': value.assetClass2Name,
        'assetClass1Name': value.assetClass1Name,
        'attributeTemplateId': value.attributeTemplateId,
    };
}
